import WizardStep from "./WizardStep";

export default class CompletedStep extends WizardStep {
  type = WizardStep.TYPE_NONE;
  name = 'Completed';
  title = 'Completed';

  getHtml() {
    return `
<div class="text-center text-success">
  <span class="icon ion-ios-checkmark-circle-outline" style="font-size: 7rem; line-height: 0;"></span>
  <div>Completed at</div>
  <div style="font-weight: 600;">${this.revenueUpdate.completed}</div>
</div>`;
  }

}